import { ExportAsSaftModal as ExportAsSaftModalComponent } from '@components'

import { Button, useModal, withModalConditionalRender } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../enums/modalId'
import { ExportsCard } from '../ExportsCard'

const ExportAsSaftModal = withModalConditionalRender(ExportAsSaftModalComponent)

export const AllData = () => {
  const { t } = useTranslation()
  const { open: handleOpenSaftModal } = useModal(ModalId.ExportAsSaftModal)

  return (
    <ExportsCard
      description={t('exports.card.all_data.description')}
      title={t('exports.card.all_data.title')}
      actionButton={
        <Button onClick={handleOpenSaftModal} variant="outlined">
          {t('exports.card.all_data.button.label')}
        </Button>
      }
    >
      <ExportAsSaftModal id={ModalId.ExportAsSaftModal} />
    </ExportsCard>
  )
}
